import React from 'react';
import Spinner from '../../../components/Spinner/Spinner';

export default function LoadingIndicatorComponent() {
  return <Spinner className="w-5 h-5 ml-3" />;
}
